import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";

import { extractErrorMessage } from "@app/api/client";

export function Loading() {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
      <CircularProgress />
    </Box>
  );
}

export function ErrorMessage({ error }: { error: unknown }) {
  return <Alert severity="error">{extractErrorMessage(error)}</Alert>;
}
